import ModernNavbar from "./ModernNavbar";
import ModernSearch from "./ModernSearch";
import styles from "./ModernHeader.module.scss";

const ModernHeader = () => {
  return (
    <header className={styles.headerContainer}>
      <ModernNavbar />
      <ModernSearch />
    </header>
  );
};

export default ModernHeader;
